import { BehaviorSubject, Observable, catchError, first, map, tap, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { OccEndpointsService, ProductImageNormalizer } from '@spartacus/core';

import { CustomProductImageNormalizer } from './custom-product-image-normalizer.service';
import { Bundle, OccBundle } from '../models';

@Injectable({
  providedIn: 'root'
})
export class BundleService {
  private bundle$ = new BehaviorSubject<Bundle>(undefined);
  private savedBundleCode: string;

  constructor(
    private occEndpointService: OccEndpointsService,
    private http: HttpClient,
    private customImageNormalizer: CustomProductImageNormalizer,
    private productImageNormalizer: ProductImageNormalizer,
    private readonly router: Router
  ) {}

  getBundle(bundleCode: string, bundleField = 'bundle', redirectToMainProduct = false): Observable<Bundle> {
    if (this.savedBundleCode === bundleCode) {
      return this.bundle$.pipe(
        first((bundle) => bundle?.id === bundleCode)
      );
    }

    if (bundleField === 'bundle') {
      this.savedBundleCode = bundleCode;
    }

    const url = this.occEndpointService.buildUrl(bundleField, {
      urlParams: { bundleCode }
    });

    return this.http.get<OccBundle>(url).pipe(
      catchError(() => {
        this.savedBundleCode = '';
        if (redirectToMainProduct) {
          const currentUrl: string = this.router.url;
          const findProductId: number = +currentUrl.split('/').slice(-1)[0].replace(/\?.+/, '');
          this.router.navigateByUrl(`/p/${findProductId}`);
        }
        return of(null);
      }),
      map((occBundle: OccBundle) => {
        return occBundle ? {
          ...occBundle,
          galleryImages: this.customImageNormalizer.normalize(occBundle.galleryImages),
          products: occBundle.products?.map((product) => this.productImageNormalizer.convert(product))
        } : null;
      }),
      tap((bundle) => {
        if (bundleField === 'bundle' && bundle !== null) {
          this.bundle$.next(bundle);
        }
      })
    );
  }
}
